// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"_2FK_66AdzkX0IsVOKs76LK","aside":"_1OxnAxsKBfrmVNnrxdDG-E","appName":"_1opegXY-4y8m-sGaot9T4B","close":"_3SrH7bDWmnPQDMyUwjsobQ","appContainer":"_2SqPyaGFFuWZaTyStquHkQ"};